import {enConfig} from './en';

export const arConfig = {
    ...enConfig.base,
    bismi:'بِسۡمِ ٱللهِ ٱلرَّحۡمَـٰنِ ٱلرَّحِيمِ',
    salaam:'ٱلسَّلَامُ عَلَيْكُمْ',
    home : 'الرئيسية',
    header:{
        signup : "التسجيل",
        signin : "الدخول",    
        signout : "خروج",
        close: "إغلاق",
        profile: "الملف الشخصي",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        about : "حول",
        article : "المقالات",
        contact : "تواصل",
        download: "تنزيل",
        joinus : "انضم إلينا",
        english : "الإنجليزية",
        setting : "الإعدادات"

    },
    
    home:{
        title : 'مرحبًا، الرجاء الدخول أو التسجيل',
        about : 'تهدف إلى تعريف الجيل الجديد بعالم جديد من المعرفة',
        connected: 'يجب أن تكون مسجلا',
    },

    profile:{
        ...enConfig.profile,
        salaam :'مرحبًا, ',
        setting:'الإعدادات',
        contact:'اتصل بنا',
        service:'خدمات',
        logout:'الخروج',
        site:'الموقع',
        profile:'الملف الشخصي',
        home:'الرئيسية',
        contact:'اتصل بنا',
        order:'الطلب',
        invoice:'الفواتير',
        login:'الدخول',
        admin:'إدارة'
    },

    blog: {
        ...enConfig.blog,
        title :'أكثر المقالات إثارة للاهتمام',
    },

    contact:{
        title:'تواصل معنا',
        message:'يرجى ملء النموذج أدناه لإرسال بريد إلكتروني إلينا',
        confirm:'تأكيد الاتصال',
        content:'يرجى ملء الرمز الذي أرسلناه إليك عبر البريد الإلكتروني لتأكيده',
        recipient:"يرجى تأكيد معلومات المستلم.",
        feedback : 'لقد تلقينا رسالتك، وسنعود إليك في أقرب وقت ممكن',
        warning : "يجب تأكيد بريدك الإلكتروني قبل المتابعة"
    },

    getApp : {
        name : 'تنزيل التطبيق الخدمات',
        info : 'تنزيل تطبيق الخدمات',
    },

    sign : {
        title:'التسجيل في أكثر صحة ',
        name:'طلب التسجيل',
        info:'إذا لم تكن عضوا بعد',
        confirmed:"تم ربط هذا الهاتف من قبل يمكنك الدخول الآن",
        confirming:"تم ربط هاتفك بنجاح عليك الدخول الآن",

        requirement: {
            telegram:"يعتمد هذا التطبيق كليا على تلغرام المثبت على هاتفك الذكي",
            required:"معلومات ضرورية",
            optional:"معلومات اختيارية",
            infos:'الرجاء إدخال الاسم ورقم الهاتف'
        },

        error: {
            name:'ينبغي الأسم',
            phone: {
                regex:"رقم الهاتف غير صحيح",
                start:"يجب أن يبدأ رقم الهاتف بـ 0",
                found:"رقم الهاتف هذا غير موجود"
            },
            problem:"مشكلة في التسجيل",
            telegram:"يجب إنشاء حساب تلغرام قبل المتابعة",
            role:"هذا الدور غير مسموح به هنا؟"

        },

        label: {
            infos: 'معلومات إضافية أو أسئلة',
            submit: 'إرسال طلب التسجيل',
            login: "تسجيل الدخول"
        },

        status : {
            hello : "مرحبا"
        },

        in : {
            code:'يرجى التأكيد بالرمز الذي توصلتم به في تلغرام',
            title:'الرمز من تلغرام',
            label:'00000'
        }
    }

}
